import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class HttpService {
	private dns = environment.backend_url;
	private httpOptions = {
		headers: new HttpHeaders(
			{
				'Content-type': 'application/json',
			}
		)
	};
	constructor(private http: HttpClient) {
		this.http = http;
	}

	public async doGet(endpoint: string): Promise<any> {
		return await this.http.get(`${this.dns}${endpoint}`, this.httpOptions).toPromise();
	}

	public setSessionId(sessionId: string) {
		localStorage.setItem("RSESSIONID", sessionId);
	}

	public setRequestsResources(resources: Array<string>) {
		let resourceString: string = resources.toString().replace("[", "").replace("]", "");
		localStorage.setItem("Resources", resourceString)
	}
}
